import { render } from "./InputCallToAction.vue?vue&type=template&id=496aa3a0"
import script from "./InputCallToAction.vue?vue&type=script&lang=js"
export * from "./InputCallToAction.vue?vue&type=script&lang=js"
script.render = render

export default script